import { z } from "zod";

export const subscriptionDiscountSchema = z.object({
  mostrar_banner: z.boolean(),
  trial: z.boolean(),
  dias_restantes: z.number().optional(),
  id: z.string().optional(),
});

export const applyDiscountSchema = z.object({
  id: z.string(),
  cupom: z.string(),
});
